import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { FeedbackAction } from "stores/Feedback/FeedbackAction";
// import { bookingTableActions } from "stores/BookingTableStore/bookingTableAction";
// import { commonActions } from "stores/common/commonActions";
const mapStateToProps = (state) => {

  return {
    FeedbackList: state.FeedbackReducerData.FeedbackList,
    isLoading:state.FeedbackReducerData.FeedbackDataLoading.isLoading
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  FeedbackReducerDataAction: FeedbackAction.getFeedbackData,
}, dispatch);


const FeedbackStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default FeedbackStore;